<template>
  <el-dialog
    :title="$t('goldWithdrawal.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="resetForm"
  >
    <div style="text-align:center">
      <p>{{ $t('goldWithdrawal.confirmDeleteGoldWithdrawal') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('goldWithdrawal.cancel') }}</el-button>
      <el-button type="primary" @click="deleteGoldWithdrawal">{{ $t('goldWithdrawal.confirmDelete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteGoldWithdrawal } from '@/api/admin/goldWithdrawal/goldWithdrawalApi'

export default {
  name: 'DeleteGoldWithdrawal',
  data() {
    return {
      dialogVisible: false,
      deleteGoldWithdrawalInfo: {}
    }
  },
  methods: {
    open(row) {
      this.deleteGoldWithdrawalInfo = { ...row }
      this.dialogVisible = true
    },
    resetForm() {
      this.deleteGoldWithdrawalInfo = {}
    },
    async deleteGoldWithdrawal() {
      try {
        await deleteGoldWithdrawal(this.deleteGoldWithdrawalInfo)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('goldWithdrawal.deleteSuccess'))
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(error.message || this.$t('goldWithdrawal.deleteFailed'))
      }
    }
  }
}
</script>